<span *ngIf="hasPrefix" class="mr-xs"> <bw-icon-legacy [iconName]="prefixIconName" size="24"></bw-icon-legacy> </span>
<span [ngClass]="[anchorStyle ? anchorStyle : '']" [ngStyle]="{color: color, 'text-decoration': anchorUnderline ? 'underline' : ''}"><ng-content></ng-content></span>
<span *ngIf="hasSuffix"><bw-icon-legacy [iconName]="suffixIconName" size="24"></bw-icon-legacy> </span>
